import { render, staticRenderFns } from "./AppHeaderNavMoreLocal.vue?vue&type=template&id=8049a884&"
import script from "./AppHeaderNavMoreLocal.vue?vue&type=script&lang=js&"
export * from "./AppHeaderNavMoreLocal.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderNavMoreLocal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports